// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1u8h0","buttons":"styles_buttons__3_0EZ"};